export enum MarketPages {
  BasicInfo = 'basic-info'
}

export default MarketPages;
